import { ReactElement, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Search from "./Search";
import UserOptions from "./UserOptions";
import { header } from "../../../shared/logos";
import styles from './Header.module.scss';
import { className } from "../../../shared/helpers";

interface HeaderProps
{
    subHeaderVisible: boolean;
    toggleSubHeader: (state: boolean) => void;
}

const Header = (props: HeaderProps): ReactElement =>
{
    const [searchVisible, setSearchVisibility] = useState(false);
    const location = useLocation();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => props.toggleSubHeader(false), [location]);

    return (
        <header {...className(styles.header, { [styles.searchVisible]: searchVisible })}>
            <button className={styles.mobileButton} onClick={() => props.toggleSubHeader(!props.subHeaderVisible)}>
                <i className="material-icons">
                    {props.subHeaderVisible ? "close" : "menu"}
                </i>
            </button>

            <Link to="/" className={styles.logo}>
                {header}
            </Link>

            <div className={styles.actions}>
                <Search searchVisible={searchVisible} setSearchVisibility={setSearchVisibility} />
                <UserOptions searchVisible={searchVisible} setSearchVisibility={setSearchVisibility} />
            </div>
        </header>
    );
}

export default Header;
